import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeStyle as _normalizeStyle, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex-grow-1 d-flex justify-end" }
const _hoisted_2 = {
  key: 0,
  class: "position-absolute badge"
}
const _hoisted_3 = { class: "flex-grow-1 d-flex justify-center" }
const _hoisted_4 = {
  key: 0,
  class: "position-absolute badge"
}
const _hoisted_5 = { class: "flex-grow-1 d-flex justify-start" }
const _hoisted_6 = {
  key: 0,
  class: "position-absolute badge"
}
const _hoisted_7 = { class: "font-size-10-600 grey-color" }
const _hoisted_8 = { class: "font-size-12-600" }

import { computed, onMounted, reactive, ref } from "vue";

import { useSettingsStore } from "@/api/store/settings";
import { useRouter } from "vue-router";

import { filesService } from "@/api/services/file";
import { filesFeedService } from "@/api/services/filesFeed";
import moment from "moment";
import Icon from "@/components/Icons/Icon.vue";
import ButtonFixed from "@/components/custom/ButtonFixed.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DocumentsView',
  setup(__props) {

const router = useRouter();

const settingsStore = useSettingsStore();

const loading = ref(false);

const state = reactive({
  activities: [] as any[],
  search: "" as string,
  sort_asc: true as boolean,
  page: 1 as number,
  tab: "home" as string,
  stats: {} as any,
});

const buttonStyle = computed(() => {
  return (
    "background: white;box-shadow: 4px 4px 10px 0px #0000000D; color: " +
    settingsStore.settings.primaryColor +
    ";"
  );
});

const getStats = () => {
  filesService.stats({ skipGlobalLoading: true }).then((response) => {
    state.stats = response;
  });
};

const getActivities = () => {
  loading.value = true;
  filesFeedService.index({ skipGlobalLoading: true }).then((response) => {
    state.activities = response.data;
  }).finally(() => {
    loading.value = false;
  });
};

const groupedActivities = computed(() => {
  const grouped = state.activities.reduce((acc, activity) => {
    const dateKey = moment(activity.created_at).format("D MMM YYYY");
    (acc[dateKey] = acc[dateKey] || []).push(activity);
    return acc;
  }, {});

  return Object.keys(grouped)
    .sort((a, b) => moment(b, "D MMM YYYY").diff(moment(a, "D MMM YYYY")))
    .reduce((sortedAcc, key) => {
      sortedAcc[key] = grouped[key];
      return sortedAcc;
    }, {});
});

const getFileType = (type) => {
  if (type.file_resource?.kind === "form") {
    return "document-form";
  } else if (type.file_resource) {
    return "document-file";
  }

  return "document-survey";
};

const getFile = (type) => {
  if (type.file_resource?.kind === "form") {
    return {
      type: "New Form",
      title: type.file_resource.title,
      action: "Shared With You",
    };
  } else if (type.file_resource) {
    return {
      type: "New Document",
      title: type.file_resource.title,
      action: "Shared With You",
    };
  }

  return {
    type: type.completed === null ? "New Survey" : "Survey",
    title: type?.survey?.name,
    action: type.completed === null ? "Added" : "Completed",
  };
};

onMounted(() => {
  getActivities();
  getStats();
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_list_item_content = _resolveComponent("v-list-item-content")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    class: "px-0 pt-0 pb-32",
    style: {"background-color":"#eee","min-height":"500px"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_sheet, {
        class: "d-flex justify-center pa-4 text-center ga-2",
        style: {"background":"none"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_sheet, {
              style: _normalizeStyle(buttonStyle.value),
              class: "pa-3 b-round-20 position-relative",
              width: "100",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'document-documents' })))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  class: "my-2",
                  icon: "mdi mdi-file-document-outline",
                  size: "40"
                }),
                _cache[4] || (_cache[4] = _createElementVNode("p", { class: "p-text-md" }, "Documents", -1)),
                (state.stats?.total_documents)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(state.stats?.total_documents), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["style"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_sheet, {
              style: _normalizeStyle(buttonStyle.value),
              class: "pa-3 b-round-20 position-relative",
              width: "100",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push({ name: 'document-forms' })))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  class: "my-2",
                  icon: "mdi mdi-file-document-edit-outline",
                  size: "40"
                }),
                _cache[5] || (_cache[5] = _createElementVNode("p", { class: "p-text-md" }, "Forms", -1)),
                (state.stats?.total_forms)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(state.stats?.total_forms), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["style"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_v_sheet, {
              style: _normalizeStyle(buttonStyle.value),
              class: "pa-3 b-round-20 position-relative",
              width: "100",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push({ name: 'document-surveys' })))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  class: "my-2",
                  icon: "mdi mdi-chart-box-outline",
                  size: "40"
                }),
                _cache[6] || (_cache[6] = _createElementVNode("p", { class: "p-text-md" }, "Surveys", -1)),
                (state.stats?.total_surveys)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(state.stats?.total_surveys), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["style"])
          ])
        ]),
        _: 1
      }),
      (loading.value)
        ? (_openBlock(), _createBlock(_component_v_card, {
            key: 0,
            class: "mt-2 mx-6 padding border-rounded"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_skeleton_loader, {
                type: "text",
                width: "50%",
                class: "mb-4"
              }),
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (n) => {
                return _createVNode(_component_v_skeleton_loader, {
                  key: n,
                  type: "list-item-two-line",
                  class: "mb-1"
                })
              }), 64))
            ]),
            _: 1
          }))
        : (Object.keys(groupedActivities.value).length > 0)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 1,
              class: "mt-2 mx-6 padding border-rounded"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "font-size-18-600 px-0" }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode(" Recent Activities ", -1)
                  ]))]),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedActivities.value, (activities, date) => {
                  return (_openBlock(), _createElementBlock("div", { key: date }, [
                    _createVNode(_component_v_row, { class: "py-2" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "px-3 py-1"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", _hoisted_7, _toDisplayString(date), 1),
                            _createVNode(_component_v_divider, { class: "mt-3" })
                          ]),
                          _: 2
                        }, 1024),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activities, (activity) => {
                          return (_openBlock(), _createBlock(_component_v_col, {
                            cols: "12",
                            class: "pa-0",
                            key: activity.id
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_content, { class: "font-size-12-400 d-flex align-center ga-2" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", null, [
                                        _createVNode(Icon, {
                                          icon: getFileType(activity),
                                          color: _unref(settingsStore).settings.primaryColor
                                        }, null, 8, ["icon", "color"])
                                      ]),
                                      _createElementVNode("p", null, [
                                        _createTextVNode(_toDisplayString(getFile(activity).type) + " ", 1),
                                        _createElementVNode("span", _hoisted_8, "'" + _toDisplayString(getFile(activity).title) + "'", 1),
                                        _createTextVNode(" " + _toDisplayString(getFile(activity).action), 1)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_divider, { class: "mt-2" })
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                }), 128))
              ]),
              _: 1
            }))
          : (!loading.value)
            ? (_openBlock(), _createBlock(_component_v_card, {
                key: 2,
                class: "mx-4 mt-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "text-h6" }, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                      _createTextVNode("Recent Activities", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createElementVNode("p", { class: "p-text" }, "No recent activities.", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
      _createVNode(ButtonFixed, {
        "color-icon": "primaryButtonColor",
        "custom-class": "text-white primary-button",
        "custom-icon-class": "add-new-circle-icon",
        icon: "add-plus-circle",
        text: "Upload Document",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (
        _unref(router).push({
          name: 'document-upload',
          params: { page: 'files-activity' },
        })
      ))
      })
    ]),
    _: 1
  }))
}
}

})